module.exports = __webpack_public_path__ + "static/media/react1Provider.53469c24.png";